import { useTheme } from '@emotion/react'
import { Box, CardMedia, Divider, Typography } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router-dom'

const Card = ({ client }) => {

  const { logo, name, description, username } = client
  //id,
  const theme = useTheme()
  const navigate = useNavigate()
  return (
    <>
      <Box sx={{
        boxShadow: theme.palette.boxShadow, borderRadius: 1, display: 'flex',
        alignItems: 'center', justifyContent: 'space-evenly', flexDirection: 'column',
        m: 1, py: 2, my: 2, cursor: 'pointer', textAlign: 'center', position: 'relative', height: '90%',
        backgroundColor: theme.palette.background.input,
      }} onClick={() => navigate(`/${username}`)} >
        <CardMedia
          component={'img'}
          alt={name}
          src={logo}
          sx={{ width: '100px', height: '100px', borderRadius: '50%' }}
        />
        <Divider sx={{ my: 1, borderColor: theme.palette.background.tap, width: '100%' }} />
        <Typography color={'primary.default'} variant="h6" sx={{ fontFamily: 'URW DIN Arabic', fontSize: 16, }} fontWeight={'medium'}>
          {name}
        </Typography>
        <Typography color={'secondary.default'} sx={{ fontFamily: 'URW DIN Arabic', fontSize: 12, }} fontWeight={'medium'}>
          {description?.slice(0, 20)}
        </Typography>
      </Box>
    </>
  )
}

export default Card